import { render, staticRenderFns } from "./FormImputedCost.vue?vue&type=template&id=5155c884&"
import script from "./FormImputedCost.vue?vue&type=script&lang=js&"
export * from "./FormImputedCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports